<div class="row">
  <div class="col-span-12 col-md-3">
    <p-datepicker [(ngModel)]="period" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="showData()"/>
  </div>

  <div class="col-span-12 col-md-9">
    <p-selectButton [options]="statTypes" [(ngModel)]="selectedType" (onChange)="changeType()"></p-selectButton>
  </div>
</div>

<p-table [value]="dailyStatistic" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
  [tableStyle]="{'min-width': '50rem'}" currentPageReportTemplate="{first} - {last} из {totalRecords} записей"
  [rowsPerPageOptions]="[10,100,500, 1000]" styleClass="p-datatable-striped" *ngIf="dailyStatistic">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="login">
        <div class="col">
          Логин
          <p-columnFilter type="text" field="login" display="menu"></p-columnFilter>
          <p-sortIcon field="login"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="first_name">
        <div class="col">
          Имя
          <p-columnFilter type="text" field="first_name" display="menu"></p-columnFilter>
          <p-sortIcon field="first_name"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="last_name">
        <div class="col">
          Фамилия
          <p-columnFilter type="text" field="last_name" display="menu"></p-columnFilter>
          <p-sortIcon field="last_name"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="client_code">
        <div class="col">
          Клиент
          <p-columnFilter type="text" field="client_code" display="menu"></p-columnFilter>
          <p-sortIcon field="client_code"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="phone">
        <div class="col">
          Телефон
          <p-columnFilter type="text" field="phone" display="menu"></p-columnFilter>
          <p-sortIcon field="phone"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="client_city">
        <div class="col">
          Город
          <p-columnFilter type="text" field="client_city" display="menu"></p-columnFilter>
          <p-sortIcon field="client_city"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="email">
        <div class="col">
          Email
          <p-columnFilter type="text" field="email" display="menu"></p-columnFilter>
          <p-sortIcon field="email"></p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="phone">
        <div class="col">
          Накладная
          <p-columnFilter type="text" field="phone" display="menu"></p-columnFilter>
          <p-sortIcon field="phone"></p-sortIcon>
        </div>
      </th>
      <th>
        <div class="col">Время</div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-client>
    <tr>
      <td class="nobr">{{client.login}}</td>
      <td class="nobr">{{client.first_name}}</td>
      <td class="nobr">{{client.last_name}}</td>
      <td class="nobr">{{client.client_code}}</td>
      <td class="nobr">{{client.phone}}</td>
      <td class="nobr">{{client.client_city }}</td>
      <td class="nobr">{{client.email}}</td>
      <td class="nobr">{{client.tracknum}}</td>
      <td class="nobr">{{client.deliver_date | date: 'HH:mm'}}</td>
    </tr>
  </ng-template>
</p-table>

<div [ngStyle]="{'text-align': 'center'}">
  <p-progressSpinner *ngIf="dataLoading" styleClass="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)" animationDuration="4s"></p-progressSpinner>
</div>


<!-- <canvas id="bar-chart-horizontal" width="800" height="450"></canvas> -->

<div>&nbsp;</div>
<h3 *ngIf="!dailyStatistic && !dataLoading">Нет данных за период</h3>